<template>
  <div>
    <div class="position-relative">

      <!-- shape Hero -->

      <section class="section-shaped my-0">
        <div class="shape shape-style-1 shape-default shape-skew">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div class="container shape-container d-flex">
          <div class="col px-0">
            <div class="row">
              <div class="col-lg-6">
                <h1 class="display-3  text-white">AI for humans
                  <span></span>
                </h1>
                <p class="lead  text-white">Arpeggio is a boutique machine learning R&D firm.
                  Our primary areas of focus are Natural Language Processing and Language Models.
                  </p>
                <!--
                <div class="btn-wrapper">
                  <base-button tag="a"
                               href="https://demos.creative-tim.com/argon-design-system/docs/components/alerts.html"
                               class="mb-3 mb-sm-0"
                               type="info"
                               icon="fa fa-code">
                    Components
                  </base-button>
                  <base-button tag="a"
                               href="https://www.creative-tim.com/product/argon-design-system"
                               class="mb-3 mb-sm-0"
                               type="white"
                               icon="ni ni-cloud-download-95">
                    Download HTML
                  </base-button>
                </div>
                -->
              </div>
            </div>
          </div>
        </div>
      </section>



      <section class="section section-lg pt-lg-0 mt--200">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-lg-12">
              <div class="row row-grid">






                <div class="col-lg-5">
                  <card class="border-0" hover shadow body-classes="py-5">

                    <div  style="text-align: center">
                      <img src="img/explainable-ai-thumb.png" width="85%" style="margin-bottom:20px;"/>
                      <h6 class="text-warning text-uppercase">Explainable AI Cheat Sheet</h6>
                    </div>
                    <p class="description mt-3">
                      Explainable AI is a set of tools and methods that allow us to understand Artificial Intelligence and Machine Learning models and their predictions.
                    </p>
                    <p class="description mt-3">
                      This is your high-level guide to the set of tools and methods that helps humans
                      understand AI/ML models and their predictions.</p>
                    <!--                    <div>-->
                    <!--                      <badge type="success" rounded>business</badge>-->
                    <!--                      <badge type="success" rounded>vision</badge>-->
                    <!--                      <badge type="success" rounded>success</badge>-->
                    <!--                    </div>-->

                    <div style="text-align: center">
                      <base-button tag="a" href="https://ex.pegg.io/" type="warning" class="mt-4">
                        Learn more
                      </base-button>
                      <br />
                      <base-button tag="a" href="https://www.youtube.com/watch?v=Yg3q5x7yDeM" type="warning" outline class="mt-4">
                          Video
                      </base-button>
                    </div>
                  </card>
                </div>




                <div class="col-lg-5">
                  <card class="border-0" hover shadow body-classes="py-5">
                    <div  style="text-align: center">
                      <img src="img/ecco-logo-480.png" width="60%" style="margin-bottom:20px;"/>
                      <h6 class="text-primary text-uppercase">Look inside language models</h6>
                    </div>
                    <p class="description mt-3">
                      At the intersection of the bleeding edge and the ancient.
                      The combination of the most advanced AIs and language -- humanity's greatest ancient technology.
                    </p>
                    <p class="description mt-3">
                      Ecco is an open-science, open-source software for exploring <i>language models</i> -- giant AI models
                      that are leading the way in Natural Language Understanding and Generation.
                      </p>
<!--                    -->
<!--                    <div>-->
<!--                      <badge type="primary" class="label-pill" rounded>Explainable-AI</badge>-->
<!--                      <badge type="light" rounded>Interpretability</badge>-->
<!--                      <badge type="secondary" rounded>NLP</badge>-->
<!--                    </div>-->
                    <div style="text-align: center">
                      <base-button tag="a" href="https://www.eccox.io" type="primary" class="mt-4">
                        Learn More
                      </base-button>
                      <br />
                      <base-button tag="a" href="https://github.com/jalammar/ecco" type="primary" outline class="mt-4">
                        Github
                      </base-button>
                      <base-button tag="a" href="https://jalammar.github.io/explaining-transformers/" type="primary" outline class="mt-4">
                        Article
                      </base-button>
                    </div>
                  </card>
                </div>



              </div>
            </div>
          </div>
        </div>
      </section>

    </div>
  </div>
</template>
<script>
export default {};
</script>
<style>
</style>
